import * as React from 'react'

import {
  ConfirmOptions,
  useConfirm,
} from '@/modules/shared/context/ConfirmContext'

export type WithConfirmProps = {
  confirm: (options: ConfirmOptions) => Promise<boolean>
}

/**
 * Wstrzykuje `confirm()` z `ConfirmContext` do komponentu klasowego.
 *
 * Stare ekrany rysowały własne okienko potwierdzenia - pomarańczowy nagłówek
 * i para kafelków „Nie"/„Tak" w stylach inline, powtórzone w każdym z nich.
 * Hooka nie da się wywołać w klasie, więc kontekst wchodzi propsem.
 *
 * Przepuszcza ref: panel administracyjny sięga po instancję zakładki.
 */
export function withConfirm<P extends WithConfirmProps>(
  Wrapped: React.ComponentType<P>,
) {
  const WithConfirm = React.forwardRef<unknown, Omit<P, 'confirm'>>(
    (props, ref) => {
      const confirm = useConfirm()
      return (
        <Wrapped
          ref={ref as any}
          {...(props as unknown as P)}
          confirm={confirm}
        />
      )
    },
  )

  WithConfirm.displayName = `withConfirm(${
    (Wrapped as any).displayName || (Wrapped as any).name || 'Component'
  })`

  return WithConfirm
}
